import * as React from "react"

const Truck = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.79 20.5" {...props}>
    <title>{"parcel-journey-3-truck-icon-2"}</title>
    <path
      d="M32.79 10.79v5.09a1.54 1.54 0 0 1-1.54 1.54h-.57a4.6 4.6 0 0 0 .06-.52 4.61 4.61 0 0 0-9.22 0 4.57 4.57 0 0 0 .05.52H11.22a4.51 4.51 0 0 0 0-.52 4.61 4.61 0 0 0-9.22 0 4.57 4.57 0 0 0 0 .52H0V0h20.2a4.55 4.55 0 0 1 3.7 1.9l3.76 5.27 3.67 1.47a2.31 2.31 0 0 1 1.46 2.15Zm-6.66 2.53a3.59 3.59 0 1 0 3.58 3.6 3.58 3.58 0 0 0-3.58-3.58Zm0 5.12a1.54 1.54 0 1 1 1.53-1.55 1.54 1.54 0 0 1-1.53 1.55ZM6.66 13.32a3.59 3.59 0 1 0 3.59 3.59 3.58 3.58 0 0 0-3.58-3.58Zm0 5.12A1.54 1.54 0 1 1 8.2 16.9a1.54 1.54 0 0 1-1.54 1.54ZM22.6 3.32a3.47 3.47 0 0 0-2.7-1.27h-3.51v5.12H25Z"
      fill="#ffffff"
    />
  </svg>
)

export default Truck
